import React from "react";
import { Button, GridColumn } from "@sumprio/ui";
import { AddIcon } from "@sumprio/ui/icons";

interface EmptyStateActionProps {
  actionLabel?: string;
  onAction?: () => void;
  actionIcon?: React.ComponentType<Record<string, unknown>>;
}

export default function EmptyStateAction({
  actionLabel,
  onAction,
  actionIcon = AddIcon,
}: EmptyStateActionProps) {
  if (!actionLabel || !onAction) return null;

  return (
    <GridColumn span={12} display="flex" justifyContent="center">
      <Button size="sm" type="brand" variant="brand-default" icon={actionIcon} onClick={onAction}>
        {actionLabel}
      </Button>
    </GridColumn>
  );
}
